import React from "react";
//import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license-pro';
import Main from "./Main";
import "./index.css";
import store from './Redux/store'
import { Provider } from 'react-redux'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Provider store={store}><Main/></Provider>)

//ReactDOM.render(
//  <Main/>,
//  document.getElementById("root")
//);